import React, {useEffect, useRef} from 'react';
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { Handle } from 'react-flow-renderer';
import { Card, ClickAwayListener, Avatar, Badge, Button, Tooltip, Input, InputAdornment, Typography, ListItemIcon, Popper, MenuItem, ListItemText } from '@material-ui/core';
import AppsRoundedIcon from '@material-ui/icons/AppsRounded';
import MoreVertRoundedIcon from '@material-ui/icons/MoreVertRounded';
import DeleteForeverRoundedIcon from '@material-ui/icons/DeleteForeverRounded';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import CreateRoundedIcon from '@material-ui/icons/CreateRounded';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';



import {
  nodeAdded, nodeDuplicated,selectDraggedNode, edgeAdded, elementUpdated, nameUpdated, elementDeleted, fetchWorkflow, nodeEdgeAdded, saveWorkflow, elementSelected,
  selectWorkflowElements, selectElementById, selectWorkflowName, selectWorkflowId, selectParentTree, selectWorkflowTemplate, selectWorkflowActive, selectCurrentElement, nodeDragged,
} from '../../features/workflow/workflowSlice'
import { isNodeReadyToOpen, getNodeStatusMessage, allStepsReady, getCanvasBadgeStatus } from '../helpers/stepReady'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  highlighted: {
    width: theme.spacing(15),
    height: theme.spacing(15),
    marginLeft: theme.spacing(0.65)
  },
  large: {
    marginLeft: theme.spacing(3.15),
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
  card: {
    position: 'relative',
    width: '450px',
    paddingBottom: '35px',
    cursor: 'pointer',
    height: '50px',
    paddingTop: '9px',
    borderRadius: '8px',
    "& > *:hover": {
      border: '1px solid #0069ea',
     // borderStyle: 'double'
    }
  },
  more: {
    zIndex: 99999,

  },
  popper: {
      border: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : 'lightgray'}`,
      borderRadius: '4px',
      padding: theme.spacing(1),
      backgroundColor: theme.palette.background.paper,
      zIndex: 999,
     // height: '100px',
      boxShadow: theme.palette.type === 'dark' ? '0 5px 5px 5px rgba(0, 0, 0, 0.5)' : '0 5px 5px 5px lightgray',
      width: '200px',
      color: theme.palette.text.primary
  }
}));

const ActionInput = (props) => {
  
  return <Input className='nodrag' startAdornment={
   <InputAdornment position="start">
     <CreateRoundedIcon style={{ color: 'silver' }} />
   </InputAdornment>
 } style={{ marginBottom: '15px', width: "300px", fontSize: '14px', fontWeight: 'bold' }}  onChange={props.onChange} defaultValue={props.value} value={props.value} id="name" placeholder="Name this step..." />
 
 }


const ActionNode = ({ data, id }) => {
  const theme = useTheme();
  const node = useSelector(selectElementById(id))
  
  // Safety check: provide default empty object if data is undefined
  const safeData = data || {};
  
  const [name, setName] = React.useState(safeData.name);
  const [blurname, setBlurName] = React.useState()
  const [app, setApp] = React.useState(safeData.type);
  const [label, setLabel] = React.useState(safeData.label);
  const [icon, setIcon] = React.useState(safeData.icon);
  const [action, setAction] = React.useState(safeData.action);
  const [actionlabel, setActionLabel] = React.useState(safeData.actionlabel)
  const [credentialId, setCredentialId] = React.useState(safeData.credential)
  const [authname, setAuthname] = React.useState(safeData.authname)
  const [url, setURL] = React.useState(safeData.url)
  const [actionTestTime, setActionTestTime] = React.useState(safeData.actionTestTime)
  const [fields, setFields] = React.useState(safeData.fields)
  const [hasauth, setHasAuth] = React.useState(safeData.hasauth)
  const [testData, setTestData] = React.useState(safeData.testData)
  const [renamingstep, setRenameStep] = React.useState(false)
  const [hover, setHover] = React.useState(false)
  const [hover2, setHover2] = React.useState(false)
  const [hover3, setHover3] = React.useState(false)
  const [nodrag, setNoDrag] = React.useState(false)
  //const haloeffect = data.testData ?? "loading"
  const [badge, setBadge] = React.useState()
  const parentTree = useSelector(selectParentTree);
  const parents = parentTree[id]
  const step_number = Object.keys(parents ?? '').length + 1
  const classes = useStyles();
  const dispatch = useDispatch();
  const currentElement = useSelector(selectCurrentElement)




  const ErrorBadge = withStyles((theme) => ({
    badge: {
      backgroundColor: 'red',
      color: 'red',
      position: 'absolute',
      boxShadow: `0 0 0 3px ${theme.palette.background.paper}`,
      },
  }))(Badge);

  const SuccessBadge = withStyles((theme) => ({
    badge: {
      backgroundColor: 'green',
      color: 'green',
      position: 'absolute',
      boxShadow: `0 0 0 3px ${theme.palette.background.paper}`,
      },
  }))(Badge);

  const WarningBadge = withStyles((theme) => ({
    badge: {
      backgroundColor: 'orange',
      color: 'orange',
      position: 'absolute',
      boxShadow: `0 0 0 3px ${theme.palette.background.paper}`,
    },
  }))(Badge);

  const openDropdown = (event) => {
    event.stopPropagation(); // prevent parent click handler from firing
    setAnchorElMenu(event.currentTarget);
    setNoDrag(true)
  }

  const saveNode = () => {
    dispatch(elementUpdated(id,
      {...data, name: name },
      null
  ));
  dispatch(saveWorkflow(1))
}
  const handleSaveClick = () => {
    dispatch(saveWorkflow(1))
  }

  const closeDropdown = (event) => {
    setAnchorElMenu(null);
    setNoDrag(false)
  }
  
  const StyledMenuItem = withStyles((theme) => ({
    root: {
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.palette.type === 'dark' 
          ? 'rgba(255, 255, 255, 0.08)' 
          : theme.palette.action.hover,
        '& .MuiListItemIcon-root': {
          color: theme.palette.text.primary,
        },
        '& .MuiListItemText-primary': {
          color: theme.palette.text.primary,
        },
      },
      '&:focus': {
        backgroundColor: theme.palette.type === 'dark' 
          ? 'rgba(255, 255, 255, 0.08)' 
          : theme.palette.action.hover,
        '& .MuiListItemIcon-root': {
          color: theme.palette.text.primary,
        },
        '& .MuiListItemText-primary': {
          color: theme.palette.text.primary,
        },
      },
    },
  }))(MenuItem);
  
  const StyledMenu = withStyles((theme) => ({
    paper: {
      border: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : '#d3d4d5'}`,
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
    },
  }))((props) => (
    <Popper className={classes.popper}
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    />
  ));

  //handling of dropdown menu
  const [anchorElMenu, setAnchorElMenu] = React.useState(null);
  const sourceRef = useRef();
  const removestep = (id) => {
   closeDropdown()
    dispatch(elementDeleted(id))
    handleSaveClick()
  }

  /* const duplicatestep = (id) => {
  
    closeDropdown()
     dispatch(nodeDuplicated('action', node.position.x + 50, node.position.y + 50, 
     data))
     handleSaveClick()
   } */

   const duplicatestep = (id) => {
    // Get all elements from the Redux store
    // Determine if this node is terminal (has no outgoing edges)
    const isTerminal = !elements.some(el => el.source === id);
    closeDropdown();
    
    // The original node (from our selector)
    const original = node; // 'node' is from useSelector(selectElementById(id))
    // Calculate a new position (directly below the original)
    const offsetY = 80; // adjust to your node height/margin
    const newX = original.position.x;
    const newY = original.position.y + offsetY;
    
    // Create new data by copying the original data and prefixing the name:
    const newData = { ...original.data, name: `Duplicated: ${original.data.name}` };
  
    if (isTerminal) {
      // For terminal nodes, we insert a new node below the original.
      // Pass the original node's id as the source so the new edge goes from the original node.
      dispatch(nodeEdgeAdded('action', newX, newY, 'filter', id, null, newData));
    } else {
      // For non-terminal nodes, we want to duplicate and preserve the connection(s)
      // Get the first outgoing edge if any:
      const outgoingEdges = elements.filter(el => el.source === id);
      const targetId = outgoingEdges.length > 0 ? outgoingEdges[0].target : null;
      const removeOriginalEdge = outgoingEdges.length > 0;
      const originalEdgeId = outgoingEdges.length > 0 ? outgoingEdges[0].id : null;
      
      dispatch(nodeDuplicated(
        original.type,
        newX,
        newY,
        id,
        targetId,
        removeOriginalEdge,
        originalEdgeId,
        newData
      ));
    }
    handleSaveClick();
  };
  

  const renameStep = (id) => {
    closeDropdown()
    setRenameStep(true)
  }

  useEffect(()=> {
    //here you will have correct value in userInput 
    saveNode()
},[name])

    useEffect(() => {
      const stepNode = node || { id, data: safeData, type: 'action' };
      setBadge(getCanvasBadgeStatus(stepNode));
    }, [node, data, safeData, id])
      const elements = useSelector(selectWorkflowElements);

      const hasOutgoingEdge = elements.some((el) => el.source === id);
      const stepReady = isNodeReadyToOpen(node || { id, data: safeData, type: 'action' });
      const stepsLocked = !allStepsReady(elements);

// --- DRAG/DROP HANDLERS ---
const handleDragStart = (event) => {
  dispatch(nodeDragged(node))
  // Here we store the dragged node's id.
  // (Assume that when starting a drag on this edge drop zone, the node to be moved
  // has been stored elsewhere—for example, in the dataTransfer. For this example,
  // we assume that the node's id is provided as a prop or via some global state.)
  // For demonstration, let's say we have it in data.draggedNodeId.
};
  const statusMessage = getNodeStatusMessage(node || { id, data: safeData, type: 'action' });

  return (
    <Tooltip title={<Typography style={{ fontSize: 14 }}>{statusMessage}</Typography>} placement="top" enterDelay={300} leaveDelay={0}>
    <div requiredExtensions="http://www.w3.org/1999/xhtml"
    draggable="true" id='edit-button-action' className={classes.card} onMouseEnter={() => setHover3(true)} onMouseLeave={() => setHover3(false)}
    onDragStart={handleDragStart}
    style={{
      opacity: stepReady ? 1 : 0.6,
      filter: stepReady ? 'none' : 'grayscale(0.4)',
      pointerEvents: stepReady ? 'auto' : 'auto',
    }}
    >
      
      <Card style={{
        boxShadow: theme.palette.type === 'dark' ? '-1px 5px 5px 1px rgba(0, 0, 0, 0.5)' : '-1px 5px 5px 1px lightgray',
        border: currentElement === id ? `3px solid ${theme.palette.primary.main}` : null, 
        backgroundColor: currentElement === id 
          ? (theme.palette.type === 'dark' 
              ? (theme.palette.primary[800] || '#002D5C')
              : (theme.palette.primary[100] || '#BBDEFB')) 
          : null
      }} className={nodrag === true ? "nodrag" : null} >
      { badge === 'error' ? 
      <ErrorBadge
      style={{float: 'left',marginTop: '20px', marginLeft:'9px'}}
      overlap="circle"
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      variant="dot"
    >
     <Avatar  style={{display: 'flex', float: 'left',marginTop: '0px', marginLeft: '0px',height:50, width:50, boxShadow: '1px 5px 5px 0px silver'}} label={data.name} src={data.icon} alt={data.name}>
     <AppsRoundedIcon style={ {width : 40,height:40 } }  />
     </Avatar>
     </ErrorBadge>
    : badge === 'warning' ? 
    <WarningBadge
      style={{float: 'left',marginTop: '20px', marginLeft:'9px'}}
      overlap="circle"
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      variant="dot"
    >
     <Avatar  style={{display: 'flex', float: 'left',marginTop: '0px', marginLeft: '0px',height:50, width:50, boxShadow: '1px 5px 5px 0px silver'}} label={data.name} src={data.icon} alt={data.name}>
     <AppsRoundedIcon style={ {width : 40,height:40 } }  />
     </Avatar>
     </WarningBadge> :
    <SuccessBadge
    style={{float: 'left',marginTop: '20px', marginLeft:'9px'}}
    overlap="circle"
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    variant="dot"
  >
   <Avatar  style={{display: 'flex', float: 'left',marginTop: '0px', marginLeft: '0px', height:50, width:50, boxShadow: '1px 5px 5px 0px silver'}} label={data.name} src={data.icon} alt={data.name}>
   <AppsRoundedIcon style={ {width : 40,height:40 } }  />
   </Avatar>
   </SuccessBadge>}
   
        <div style={{ display: 'block', float: 'left', marginLeft: '10px' }}>
          <Typography style={{ fontSize: '14px', color: 'gray', marginTop: '20px' }}>Action</Typography>
          
            { renamingstep ? <div onBlur={()=>{ setRenameStep(false);setName(blurname); handleSaveClick()}}><ActionInput onChange={e => { setBlurName(e.target.value); }} defaultValue={node ? node.data.name : data.name} value={blurname}  /></div>
          
            :
             <Typography noWrap={true} style={{display: 'block', marginTop: '0px', marginBottom: '20px', width: '250px', fontSize: '20px', fontWeight: 'bolder' }} >{step_number + ". "} {node ? node.data.name : data.name}</Typography> }
            
        </div>
        
        <div id='edit-button-action' style={{position: 'absolute',display:'flex', float:'right', marginTop: '30px', right: 50}} >
        {hover3 === true ? <Button variant="contained" color="primary" >View</Button> : null}
        </div>
        <ClickAwayListener onClickAway={closeDropdown}>
        
        <div className="nodrag" style={{ cursor: 'pointer', float: 'right', marginRight: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '45px' }}>
          <MoreVertRoundedIcon style={{ position: 'absolute', float: 'right', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={openDropdown} />
          
          <StyledMenu 
            id="customized-menu"
            anchorEl={anchorElMenu}
            
            open={Boolean(anchorElMenu)}
            onClose={closeDropdown}
          >
            <StyledMenuItem className="nodrag"  onClick={() => renameStep(node.id) }>
              <ListItemIcon>
                <EditRoundedIcon fontSize="small" style={{ color: theme.palette.text.primary }} />
              </ListItemIcon>
              <ListItemText style={{ marginRight: 20 }} primary="Rename Step" />
            </StyledMenuItem>
            <StyledMenuItem className="nodrag" onClick={() => duplicatestep(node.id)}>
              <ListItemIcon>
                <FileCopyOutlinedIcon fontSize="small" style={{ color: theme.palette.text.primary }} />
              </ListItemIcon>
              <ListItemText style={{ marginRight: 20 }} primary="Duplicate" />
            </StyledMenuItem>
            <StyledMenuItem className="nodrag" onClick={() => removestep(node.id)}>
              <ListItemIcon>
                <DeleteForeverRoundedIcon fontSize="small" style={{ color: theme.palette.error.main }} />
              </ListItemIcon>
              <ListItemText style={{ marginRight: 20 }} primary="Delete Step" />
            </StyledMenuItem>
          </StyledMenu>
        </div>
        </ClickAwayListener>
      </Card>

      <Handle style={hover === true ? {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '20px',
        height: 20,
        width: 20,
        borderRadius: 50,
        //border: '1.5px solid gray',
        boxShadow: theme.palette.type === 'dark' ? '0 3px 5px 2px rgba(0, 0, 0, 0.5)' : '0 3px 5px 2px lightgray',
        cursor: 'default',
        backgroundPosition: 'center center', backgroundImage: "url('/circle.svg')"
      } : {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '20px',
        height: 20,
        width: 20,
        borderRadius: 50,
        //border: '1px solid gray',
        cursor: 'default',
        backgroundPosition: 'center center', backgroundImage: "url('/circle.svg')"
      }}
        type="target" position="top"
        // isConnectable={false}
        onMouseEnter={() => setHover(true)}
        onMouseOut={() => setHover(false)}
      />
      {hasOutgoingEdge ? 
      <Tooltip title={stepsLocked ? <Typography style={{fontSize: '14px'}}>Finish configuring existing steps first</Typography> : <Typography style={{fontSize: '16px'}}>Add path</Typography>} placement="right">
        <Handle style={hover2 === true && !stepsLocked ? {
          backgroundColor: theme.palette.primary.main,
          marginBottom: '-15px',
          height: 20,
          width: 20,
          borderRadius: 50,
          boxShadow: theme.palette.type === 'dark' ? '0 3px 5px 2px rgba(0, 0, 0, 0.5)' : '0 3px 5px 2px lightgray',
          cursor: stepsLocked ? 'not-allowed' : 'pointer',
          opacity: stepsLocked ? 0.5 : 1,
          backgroundPosition: 'center center', backgroundImage: "url('/branch.svg')"
        } : {
          backgroundColor: theme.palette.primary.main,
          marginBottom: '-15px',
          height: 20,
          width: 20,
          borderRadius: 50,
          cursor: stepsLocked ? 'not-allowed' : 'pointer',
          opacity: stepsLocked ? 0.5 : 1,
          backgroundPosition: 'center center', backgroundImage: "url('/branch.svg')"
        }}
          type="source"
          position="bottom"
          id="a"
          isConnectable={!stepsLocked}
          onMouseEnter={() => setHover2(true)}
          onMouseOut={() => setHover2(false)}
        />
      </Tooltip> :
       <Tooltip title={stepsLocked ? <Typography style={{fontSize: '14px'}}>Finish configuring existing steps first</Typography> : <Typography style={{fontSize: '16px'}}>Add step</Typography>} placement="right">
       <Handle style={hover2 === true && !stepsLocked ? {
         backgroundColor: theme.palette.primary.main,
         marginBottom: '-15px',
         height: 20,
         width: 20,
         borderRadius: 50,
         boxShadow: theme.palette.type === 'dark' ? '0 3px 5px 2px rgba(0, 0, 0, 0.5)' : '0 3px 5px 2px lightgray',
         cursor: stepsLocked ? 'not-allowed' : 'pointer',
         opacity: stepsLocked ? 0.5 : 1,
         backgroundPosition: 'center center', backgroundImage: "url('/add-circle.svg')"
       } : {
         backgroundColor: theme.palette.primary.main,
         marginBottom: '-15px',
         height: 20,
         width: 20,
         borderRadius: 50,
         cursor: stepsLocked ? 'not-allowed' : 'pointer',
         opacity: stepsLocked ? 0.5 : 1,
         backgroundPosition: 'center center', backgroundImage: "url('/add-circle.svg')"
       }}
         type="source"
         position="bottom"
         id="a"
         isConnectable={!stepsLocked}
         onMouseEnter={() => setHover2(true)}
         onMouseOut={() => setHover2(false)}
       />
     </Tooltip>
}
    </div>
    </Tooltip>
  );
};

export default ActionNode;